export default __webpack_public_path__ + "static/media/ic-coberturas-adicionales.4802cee9.svg";